import React, { Fragment } from 'react';
import "./responses.css"
import Spinner from "../spinner/spinner-component";


const Responses = ({responsesTotal, responsesAfter, loading, error}) => {

  return (
    <div className="responses_container" style={{textAlign: loading ? 'center' : 'left'}}>
      {
        error ?
          <span style={{alignSelf: 'center'}}>{ error }</span>
          :
          null
      }
      {
        !loading && !error ?
          (
            <Fragment>
              <div className="responses_container__total">
                <span style={{fontSize: '17px'}}>Responses total: {responsesTotal}</span>
              </div>
              <div className="responses_container__after">
                <span style={{fontSize: '17px'}}>Responses after filter: {responsesAfter}</span>
              </div>
            </Fragment>
          )
          :
          <Spinner
            loading={loading}
            left="110px"
            top="25px"
            fontSize="18px"
          />
      }

    </div>
  )

};




export default Responses;


// WEBPACK FOOTER //
// ./src/components/responses/responses-component.js